import React, { useEffect, useState } from "react";
import { postGenerateQrCode, postRemoveQrCode, postVerifyQrCode } from "../../../../services/CommonService";
import { toast } from "react-toastify";
import Utils from "../../../../utils";

function Security() {

    const [loading, setLoading] = useState(false);
    const [qrUrl, setQrUrl] = useState('');
    const [accountName, setAccountName] = useState('');
    const [yourKey, setYourKey] = useState('');
    const [isVerified, setIsVerified] = useState(false);
    const [code, setCode] = useState('');
    let errorsObj = {
        code: ''
    };
    const [errors, setErrors] = useState(errorsObj);

    useEffect(() => {
        postGenerateQrCode({})
            .then(response => {
                setIsVerified(response.data.is_verified);
                setQrUrl(response.data.url);
                setAccountName(response.data.data.qr_account_name);
                setYourKey(response.data.data.qr_key);
            })
            .catch(err => {

            });
    }, []);

    const handleVerifyCode = (e) => {
        e.preventDefault();

        let error = false;
        let errorObj = { ...errorsObj };
        if (!code) {
            error = true;
            errorObj.code = 'Please enter the code';
        }

        setErrors(errorObj);

        if (error) return;

        setLoading(true);
        let obj = {
            code: code
        };
        postVerifyQrCode(obj)
            .then(response => {
                setIsVerified(true);
                setLoading(false);
                toast.success(response.data.message);
            })
            .catch(err => {
                setLoading(false);
                toast.error(Utils.getErrorMessage(err));
            });
    };

    const handleRemoveCode = (e) => {
        e.preventDefault();

        setLoading(true);
        postRemoveQrCode({})
            .then(response => {
                setLoading(false);
                setIsVerified(false);
                setCode('');
                toast.success(response.data.message);
            })
            .catch(err => {
                setLoading(false);
                toast.error(Utils.getErrorMessage(err));
            });
    };

    return (
        <>
            {loading && <div className="page-loading">
                <img src="/images/loader.gif" alt="loader" />
            </div>}
            <div className="tab-pane p-3" id="nav-Security" role="tabpanel" aria-labelledby="nav-Security-tab">
                <div className="p-3">
                    <h2 className="sub_main_title mb-2">Setup Google Authentication App.</h2>
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="security_steps mb-2">
                                <label>
                                    <span className="security_count">1</span>Download Google Authentication App
                                </label>
                                <p>Install Google authenticator app from Apple App store or Google Play Store</p>
                            </div>
                            <div className="security_steps mb-2">
                                <label>
                                    <span className="security_count">2</span>Scan this Barcode
                                </label>
                                <p>Use your authenticator app to scan the barcode below.</p>
                                <div className="d-flex align-items-center mt-3">
                                    {qrUrl && (
                                        <img src={qrUrl} alt="qr img" className="me-3" />
                                    )}

                                    {accountName && yourKey && (
                                        <div>
                                            <p>If you are unable to scan this barcode, manually enter the below Code.</p>
                                            <span className="scanner_id mt-2">Account Name : {accountName}</span>
                                            <br />
                                            <span className="scanner_id mt-2">Your Key : {yourKey}</span>
                                        </div>
                                    )}
                                </div>
                            </div>
                            {!isVerified && (
                                <div className="security_steps mb-2 step_wizard_content ">
                                    <label>
                                        <span className="security_count">3</span>Enter your Authentication Code
                                    </label>
                                    <p>Enter the 6-digit code generated by your authenticator app.</p>
                                    <div className="mb-4 mt-3">
                                        <input type="text" className="form-control w-25 w_sm_100" value={code}
                                            onChange={(e) => setCode(e.target.value)} placeholder="Authentication Code" />
                                        {errors.code && (<div className="text-danger">{errors.code}</div>)}
                                    </div>
                                </div>
                            )}
                            <div className="tab_footer_button ">
                                {!isVerified && (
                                    <button type="button" onClick={handleVerifyCode} className="btn btn-save">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                            <path d="M2 1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H9.5a1 1 0 0 0-1 1v7.293l2.646-2.647a.5.5 0 0 1 .708.708l-3.5 3.5a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L7.5 9.293V2a2 2 0 0 1 2-2H14a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h2.5a.5.5 0 0 1 0 1H2z" />
                                        </svg>
                                        Submit
                                    </button>
                                )}
                                {isVerified && (
                                    <button type="button" onClick={handleRemoveCode}
                                        className="btn btn-save">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                            <path d="M2 1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H9.5a1 1 0 0 0-1 1v7.293l2.646-2.647a.5.5 0 0 1 .708.708l-3.5 3.5a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L7.5 9.293V2a2 2 0 0 1 2-2H14a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h2.5a.5.5 0 0 1 0 1H2z" />
                                        </svg>
                                        Delete Authentication
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Security;